import { render, staticRenderFns } from "./CartaoCredito.vue?vue&type=template&id=1b72d49e&"
import script from "./CartaoCredito.vue?vue&type=script&lang=js&"
export * from "./CartaoCredito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports